import request from '@/config/axios'

/**
 * 模块用户管理 - 只查询在对应模块产生过业务行为的会员用户
 */
export const getModuleUserPage = (module: string, params: any) =>
  request.get({ url: `/${module}/module-user/user-page`, params })

export const getModuleUserDetail = (id: number) =>
  request.get({ url: `/member/user/get`, params: { id } })

export const updateModuleUser = (data: any) =>
  request.put({ url: `/member/user/update`, data })

/**
 * 模块会员管理 - 调用系统会员表（租户下会员）
 */
export const getModuleMemberPage = (module: string, params: any) =>
  request.get({ url: `/${module}/module-user/member-page`, params })

export const getModuleMemberDetail = (id: number) =>
  request.get({ url: `/member/user/get`, params: { id } })

export const updateModuleMemberLevel = (data: any) =>
  request.put({ url: `/member/user/update-level`, data })

export const updateModuleMemberPoint = (data: any) =>
  request.put({ url: `/member/user/update-point`, data })

export const updateModuleUserPassword = (data: any) =>
  request.put({ url: `/member/user/update-password`, data })

/** 新增模块会员/用户（管理端手动建档，如测试账号） */
export const createModuleMember = (data: any) =>
  request.post({ url: `/member/user/create`, data })
